export default "__VITE_ASSET__DkWOuLpn__"